import React, { useState, useEffect } from "react";
import Leftpanel from "../layout/Leftpanel";
import Header from "../layout/Header";
import Multiselect from "../Multiselect";
import { useParams, useSearchParams, useLocation } from "react-router-dom";
import { getUserById } from "../../../service/AddUser/AddUserService";
import SpinnerComponent from "../../components/SpinnerComponent";
import {
  getAllProductDetailslist,
  getInvoiceSupplierList,
} from "../../../service/Product/ProductService";
import Select from "react-select";
import { useTranslation } from "react-i18next";

const Userdetails = (props) => {
  const { t } = useTranslation();
  const location = useLocation();
  const industryId = new URLSearchParams(location.search);

  const { logo } = props;
  const [image, setImage] = useState({ preview: "", raw: "" });
  const [getImage, setGetImage] = useState(null);
  const [getImageresult, setGetImageresult] = useState("");
  const [userById, setUserById] = useState({});
  const [userDepartmentById, setUserDepartmentById] = useState([]);
  const [userModuleById, setUserModuleById] = useState([]);
  const [accountKey, setAccountKey] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [invoiceSupplierDataList, setAllInvoiceSupplierDataList] = useState([]);
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [supplier, setSupplier] = useState([]);
  const [myArrayDepartment, setMyArraySupplier] = useState([]);
//  console.log("selectedOptions", invoiceSupplierDataList);

  useEffect(() => {
    getallUserList();
    getInvoiceSupplierDataList();
  }, []);

  async function getInvoiceSupplierDataList() {
    setIsLoading(true);
    getInvoiceSupplierList().then(function (result) {
      const response = result?.data;
    //  console.log("resposne", response);
      setAllInvoiceSupplierDataList(response?.data?.SuppliersList);
      setIsLoading(false);
    });
  }

  async function getallUserList() {
    setIsLoading(true);
    getUserById(industryId.get(`id`)).then(function (result) {
      const response = result.data;
    //  console.log(response, "response");
      setUserById(response?.data?.employee);
      setUserDepartmentById(
        response?.data?.employee?.SelectedUserDepartments,
        "SelectedUserDepartments"
      );
      setUserModuleById(
        response?.data?.employee?.SelectedUserModules,
        "SelectedUserDepartments"
      );
      setAccountKey(response?.data?.employee?.accountKey);
      setIsLoading(false);
      // setDepartmentId(response?.data?.businessUnit?.Departments);
    });
  }

  const onFile = (event) => {
  //  console.log(event.target.files[0], "filee");
    if (event["target"].files.length > 0) {
      const file = event["target"].files[0];
      // setUserData({...userData, profileImage : file});
      setImage({
        preview: URL.createObjectURL(event.target.files[0]),
        raw: event.target.files[0],
      });
    //  console.log(image, "101823");
      setGetImage(file);
      setGetImageresult(file.name);
      //     const reader = new FileReader();
      //     reader.readAsDataURL(file);
      //     reader.onload = (event) => {
      //         setGetImageresult(reader.result);
      //   };
    }
  };

  const handleChange = (e) => {
    if (e.target.files.length) {
      setImage({
        preview: URL.createObjectURL(e.target.files[0]),
        raw: e.target.files[0],
      });
    //  console.log(image, "101823");
    }
  };
  const onSuppliers = (e) => {
  //  console.log("eeeeee", e);
    setSelectedOptions(e);
  };

  return (
    <div className="container-fluid">
      <div className="dbMain users">
        <Leftpanel breadcm={t("configuration")} />
        <div className="dbRight">
          <Header link="/user" title={t("user_view")} description="" />
          {isLoading && <SpinnerComponent isLoading={isLoading} />}
          <div className="commonBase">
            <form>
              <div className="browseimg">
                <div className="upld">
                  <label htmlFor="upload-button" className="uploadBtn">
                    <img
                      src={userById?.profilePic}
                      alt="dummy"
                      width="300"
                      height="300"
                    />
                  </label>
                  {/* <p className=" m-0">{t('upload_profile_image')}</p> */}
                  <br />
                </div>
              </div>
              <div className="row">
                <div className="col-md-6 mb-3">
                  <label htmlFor="floatName">{t("name")}</label>
                  <div className="form-floating">
                    <input
                      type="text"
                      id="floatName"
                      className="form-control"
                      placeholder=""
                      name=""
                      value={userById?.name}
                    />
                    <label htmlFor="floatName">{t("name")}</label>
                  </div>
                </div>
                <div className="col-md-6 mb-3">
                  <label htmlFor="shortName">{t("short_name")}</label>
                  <div className="form-floating">
                    <input
                      type="text"
                      id="shortName"
                      className="form-control"
                      placeholder=""
                      name=""
                      value={userById?.shortName}
                    />
                    <label htmlFor="shortName">{t("short_name")}</label>
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-md-6 mb-3 checkmail">
                  <label htmlFor="emailaddr">{t("email")}</label>
                  <div className="form-floating">
                    <input
                      type="email"
                      id="emailaddr"
                      className="form-control"
                      placeholder={t("email")}
                      name=""
                      value={userById?.email}
                    />
                    <i className="fa-solid fa-circle-check"></i>
                    <label htmlFor="emailaddr">{t("email")}</label>
                  </div>
                </div>
                <div className="col-md-6 mb-3 checkmail">
                  <label htmlFor="conct">{t("contact_number")}</label>
                  <div className="form-floating">
                    <input
                      type="text"
                      id="conct"
                      className="form-control"
                      placeholder={t("contact_number")}
                      name=""
                      value={userById?.phone}
                    />
                    <label htmlFor="conct">{t("contact_number")}</label>
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-md-6 mb-3">
                  <label htmlFor="ivp">{t("assigned_department")}</label>
                  <div className="form-floating">
                    {userDepartmentById?.map((d) => (
                      <input
                        key={d?.Department?.id} // Assuming Department has a unique id
                        type="text"
                        id="ivp"
                        className="form-control"
                        placeholder=""
                        name=""
                        value={d?.Department?.name}
                        readOnly
                      />
                    ))}
                    <label htmlFor="ivp">{t("assigned_department")}</label>
                  </div>
                </div>
                <div className="col-md-6 mb-3">
                  <label htmlFor="accountingKey">{t("accounting_key")}</label>
                  <div className="form-floating">
                    <input
                      type="text"
                      id="accountingKey"
                      className="form-control"
                      placeholder={t("accounting_key")}
                      name=""
                      value={accountKey}
                    />
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-md-12 mb-3">
                  <label htmlFor="overview">{t("overview")}</label>
                  <div className="form-floating">
                    <textarea
                      className="form-control"
                      id="overview"
                      placeholder={t("overview")}
                      value={userById?.overview}
                    ></textarea>
                    <label htmlFor="overview">{t("overview")}</label>
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-md-12 mb-3">
                  <label htmlFor="jobRole">{t("assigned_job_role")}</label>
                  <div className="form-floating">
                    <input
                      type="text"
                      id="jobRole"
                      className="form-control"
                      placeholder=""
                      name=""
                      value={userById?.UserJobRole?.name}
                    />
                    <label htmlFor="jobRole">{t("assigned_job_role")}</label>
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-md-12 mb-3 multiSlct">
                  <label htmlFor="Supplier">{t("suppliers")}</label>

                  <div
                    style={{
                      border: "1px solid #d5cfcf",
                      padding: "10px",
                      borderRadius: "5px",
                      minHeight: "43px",
                    }}
                  >
                    {userById?.SelectedUserSuppliers?.map((data, i) =>
                      i === userById?.SelectedUserSuppliers?.length - 1 ? (
                        <span>{` ${data?.Supplier?.name} `}</span>
                      ) : (
                        <span>{` ${data?.Supplier?.name} ,`}</span>
                      )
                    )}
                  </div>
                </div>
              </div>

              {/* <button type="button" className='commonButton'>{t('save')}</button> */}
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Userdetails;
